// extracted by mini-css-extract-plugin
export default {"DataSecurity":"DataSecurity_DataSecurity__vEkS7","Background":"DataSecurity_Background__58S93"};